module.exports = __webpack_public_path__ + "img/client-farmacia-confiaca.aee12eee.jpg";